// src/app/modules/kumariRemitIpo/redux/saga.ts
import {call, put, takeLatest} from 'redux-saga/effects'
import {toast} from 'react-toastify'
import * as constants from './constants'
import * as service from './service'

function* cifLookupSaga(action: any): any {
  try {
    const response = yield call(service.cifLookup, action.payload.account_number)
    yield put({type: constants.KRI_CIF_LOOKUP_SUCCESS, payload: response.data})
  } catch (e: any) {
    yield put({type: constants.KRI_CIF_LOOKUP_FAILURE, payload: e.message})
  }
}

function* fetchListSaga(action: any): any {
  try {
    const response = yield call(service.fetchApplicationList, action.payload)
    const {data, meta} = response.data
    yield put({type: constants.KRI_FETCH_LIST_SUCCESS, payload: {data, total: meta?.total ?? 0}})
  } catch (e: any) {
    yield put({type: constants.KRI_FETCH_LIST_FAILURE})
  }
}

function* submitSaga(action: any): any {
  try {
    const {data, onSuccess} = action.payload
    const response = yield call(service.submitApplication, data)
    yield put({type: constants.KRI_SUBMIT_SUCCESS})
    toast.success(`Application submitted. Ref: ${response.data.case_no}`)
    if (onSuccess) onSuccess()
  } catch (e: any) {
    yield put({type: constants.KRI_SUBMIT_FAILURE, payload: e.message})
    toast.error('Submission failed. Please try again.')
  }
}

function* fetchCaseSaga(action: any): any {
  try {
    const response = yield call(service.fetchCase, action.payload.case_id)
    yield put({type: constants.KRI_FETCH_CASE_SUCCESS, payload: response.data.data})
  } catch (e: any) {
    yield put({type: constants.KRI_FETCH_CASE_FAILURE})
  }
}

function* checkerActionSaga(action: any): any {
  try {
    const {action: act, case_id, remarks, onSuccess} = action.payload
    yield call(service.checkerAction, act, case_id, remarks)
    yield put({type: constants.KRI_CHECKER_ACTION_SUCCESS})
    toast.success(`Case ${act}d successfully.`)
    if (onSuccess) onSuccess()
  } catch (e: any) {
    yield put({type: constants.KRI_CHECKER_ACTION_FAILURE, payload: e.message})
    toast.error('Action failed.')
  }
}

export function* saga() {
  yield takeLatest(constants.KRI_CIF_LOOKUP_REQUEST, cifLookupSaga)
  yield takeLatest(constants.KRI_FETCH_LIST_REQUEST, fetchListSaga)
  yield takeLatest(constants.KRI_SUBMIT_REQUEST, submitSaga)
  yield takeLatest(constants.KRI_FETCH_CASE_REQUEST, fetchCaseSaga)
  yield takeLatest(constants.KRI_CHECKER_ACTION_REQUEST, checkerActionSaga)
}
